module.exports = require('./helpers/bundle-url').getBundleURL('hstjT') + "close.bc7dfc3c.svg";